<script>
    import {createEventDispatcher} from 'svelte/internal';
    import {clickOutside} from "../../lib/clickOutside";
    import {setFocusTo, arrayIndex, upCaseStr} from "../../lib/lib";
    import AppIcon from "../icons/AppIcon.svelte";

    export let id = null;
    export let value;
    export let values = [];
    export let disabled = false;

    let showDropdown = false;
    // let isStringValues = false;
    let listIndex = -1;

    const dispatch = createEventDispatcher();

    const handleEscapeKey = event => {
        if (event.key === 'Escape') {
            closeDropdown();
        }
    }

    const onKeyDown = (event) => {
        if (showDropdown) {
            if (event.key === 'Enter') {
                if (listIndex > -1) {
                    onSelect(values[listIndex]);
                } else {
                    closeDropdown();
                }
            } else if (event.key === 'ArrowDown') {
                event.preventDefault();
                listIndex++;
                if (listIndex > values.length - 1) {
                    listIndex = 0;
                }
            } else if (event.key === 'ArrowUp') {
                event.preventDefault();
                listIndex--;
                if (listIndex < 0) {
                    listIndex = values.length - 1;
                }
            }
        } else {
            if (event.key === 'Enter') {
                openDropdown();
            }
        }
    }

    const onFocus = () => {
        if (!value || value === '' && values.length > 0) {
            setTimeout(() => {
                openDropdown();
            }, 200)

        }
    }

    const onChange = (event) => {
        dispatch("change", value);
    }

    const toggleDropdown = () => {
        if (!showDropdown) {
            openDropdown();
        } else {
            closeDropdown();
        }
    }

    const openDropdown = () => {
        showDropdown = true;
        document.addEventListener('keydown', handleEscapeKey);
        listIndex = arrayIndex(values, value);
    }

    const closeDropdown = () => {
        showDropdown = false;
        listIndex = -1;
        document.removeEventListener('keydown', handleEscapeKey);
    }

    const onSelect = (item) => {
        closeDropdown();
        // if (isStringValues) {
        value = item;
        // } else {
        //     value = item.name;
        // }
        dispatch("change", value);
        setFocusTo(id);
    }

    if (!id) {
        id = 'control' + Math.floor(Math.random() * 30000);
    }

    // isStringValues = values => values.every(i => typeof i === "string");
</script>

<div class="dropdown-container">
    <div class="position-relative">
        <input type="text" class="form-control" id={id} bind:value={value}
               on:focus={onFocus} on:keydown={onKeyDown} on:change={onChange} {disabled}>
        {#if !disabled}
            <button class="btn-reset toggler" on:click={toggleDropdown}>
                ▼
            </button>
        {/if}
    </div>
    {#if showDropdown}
        <ul class="dropdown" use:clickOutside on:click_outside="{ closeDropdown }">
            <!--{#if isStringValues}-->
            {#each values as item, index}
                <li>
                    <button class="dropdown-item py-2" class:selected={index == listIndex}
                            on:click={() => onSelect(item)}>{item}</button>
                </li>
            {/each}
        </ul>
    {/if}
</div>

<style>
    .toggler {
        position: absolute;
        top: 50%;
        right: 1px;
        transform: translateY(-50%);
        height: 100%;
        font-size: 9px;
        color: #7d6695;
        padding: 5px 8px;
    }
</style>